"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNodeData = void 0;
const getNodeData = (props) => {
    const { node, nestingLevel, selected, select, download, isOpenByDefault } = props;
    return {
        data: {
            download,
            select,
            selected,
            id: node.value.id,
            isOpenByDefault,
            nestingLevel,
            node,
        },
        nestingLevel,
        node: node.value,
    };
};
exports.getNodeData = getNodeData;
//# sourceMappingURL=tree-utils.js.map